import { apiClient } from './api-client.js';
import { CONFIG } from './config.js';

/**
 * Protects routes by checking authentication status
 * @returns {Promise<boolean>} Whether the user is authenticated
 */
export async function protectRoute() {
    // Skip auth check if we're on the login page
    if (window.location.pathname === '/') {
        return false;
    }

    const token = localStorage.getItem(CONFIG.TOKEN_STORAGE_KEY);
    
    // If no token, redirect to login
    if (!token) {
        apiClient.redirectToLogin();
        return false;
    }

    // Validate session before allowing access
    try {
        const isValid = await apiClient.validateSession();
        if (!isValid) {
            apiClient.logout();
            apiClient.redirectToLogin();
            return false;
        }
        return true;
    } catch (error) {
        apiClient.redirectToLogin();
        return false;
    }
}

/**
 * Initialize authentication and handle route protection
 * @returns {Promise<void>}
 */
export async function initAuth() {
    // If we're on the login page and already authenticated, redirect to docs
    if (window.location.pathname === '/' && localStorage.getItem(CONFIG.TOKEN_STORAGE_KEY)) {
        window.location.href = '/docs/';
        return;
    }

    // Protect all routes under /docs
    if (window.location.pathname.startsWith('/docs')) {
        const isAuthenticated = await protectRoute();
        if (!isAuthenticated) {
            return;
        }
    }
}

// Initialize auth when this module is loaded
initAuth().catch(() => {});
